<template>
  <item-ferramenta-estudo>
    <template slot="titulo">
      <i class="fas fa-brain"></i> Memorize
    </template>
    <div class="row boxes-resumos-sala">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="cartao in cartoesMemoria">
        <div class="text-center">
          <a target="_blank" :href="cartao.url">
            <img src="https://s3.amazonaws.com/jaleko-blog-files/wp-content/uploads/2019/05/13133636/nervo-craniano-OPTICO-375x195.png" class="img-fluid"/>
          </a>
          <p>{{ cartao.descricao }}</p>
        </div>
      </div>
    </div>
  </item-ferramenta-estudo>
</template>

<script>
import ItemFerramentaEstudo from '@/modules/SalaAula/components/ferramenta-estudo/ItemFerramentaEstudo'

export default {
  name: 'Memorize',
  components: { ItemFerramentaEstudo },
  props: {
    cartoesMemoria: Array
  }
}
</script>

<style scoped>

</style>
